import { JSX } from "react";

export const ChevronLeft = (): JSX.Element => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="21"
            viewBox="0 0 12 21"
            fill="none"
        >
            <path
                d="M11.835 2.3701L10.055 0.600098L0.165039 10.5001L10.065 20.4001L11.835 18.6301L3.70504 10.5001L11.835 2.3701Z"
                fill="white"
            />
        </svg>
    );
};
